import getDomainPathFromPath
from 'modules/redux/utils/get-domain-path-from-path'

function getDefaultDomainListPathFromPath (path) {
  return `${getDomainPathFromPath(path)}.all`
}

export default getDefaultDomainListPathFromPath
